import { render } from "./AdminApp.vue?vue&type=template&id=746fd16e&scoped=true"
import script from "./AdminApp.vue?vue&type=script&lang=js"
export * from "./AdminApp.vue?vue&type=script&lang=js"

import "./AdminApp.vue?vue&type=style&index=0&id=746fd16e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-746fd16e"

export default script